import React, { useState } from 'react';
import { TableCertifications } from './components/TableCertifications';
interface UploadFilesProps {
	
}

const CertificationsDelivery: React.FC<UploadFilesProps> = ({

}) => {

	return (
      <div>
       <h1 style={{ fontSize: "1.5rem" }}>Entrega de certificaciones</h1>
       <div>
        <TableCertifications />
       </div>
      </div>
	);
};

export default React.memo(CertificationsDelivery);
